<main style="margin: 25px">
  <mat-list>
    <mat-list-item>
      6/18/2021: Added changelog, made footer more mobile friendly, made navbar
      slightly transparent, added padding to events.
    </mat-list-item>
  </mat-list>
</main>
